<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>

<h3>Recent Orders</h3>

<div class="container">
  <div class="row">
    @if (staffMember === true) {
      <div>
        <div class="form-group"  [formGroup]="searchForm">
          <div class="form-row">
            <div class="col-md-12">
              <label for="email">Account Number</label>
              <input type="text" class="form-control" id="fname"
                formControlName="accountNumber"
                placeholder="Account Number">
            </div>
          </div>
        </div>
      </div>
    }
    <div class="table-responsive">
      <table class="table table-striped fullwidth">
        <thead>
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Your Ref</th>
            <th scope="col">Products</th>
            <th scope="col">Our Ref</th>
            <th scope="col">Placed</th>
            <th scope="col">Order Tracking</th>
            <th scope="col">Total Price</th>

          </tr>
        </thead>
        <tbody>
          @for (order of orders; track order) {
            <tr>
              <th scope="row"><span>{{ order.id }}</span></th>
              <td>{{order.custRef}}</td>
              <td> @for (line of order.products; track line) {
                <span>
                  {{line.colourName}} <br />
                  Quantity: {{line.qtyLength}}
                </span>
              }
            </td>
            <td>{{order.realitexOrderNo}}</td>
            <td>{{order.orderDate}}</td>
            <td> @for (consignment of order.consignments; track consignment) {
              <span>
                <a href=""> {{consignment.carrierName}}</a> <br />
                Status: {{consignment.status}}
              </span>
            }
          </td>
          <td>{{order.fullTotal}}</td>
        </tr>
      }
    </tbody>
  </table>


</div>

<div>
</div>
</div>
</div>
